<template>
    <section class="section_padding fligh_confirmation">
        <div class="container">
            <div class="row">
                <div class="col-md-12 m-0">
                    <div
                        v-if="(is_self_paying == 1 && sp_can_book_hotel && need_payment == 0) || (sp_can_book_hotel && guest_packages.length == 0)">
                        <form class="needs-validation" novalidate>
                            <div class="clearfix">
                                <div class="itinerary-content ib-con mb20">
                                    <div class="row no-margin align-items-center">
                                        <div class="col-md-6 col-6">
                                            <img src="@/assets/img/icons/hotels.png">
                                            <div class="inline-middle pl-3 pr-3">
                                                <h4 class="bold  mb0">{{ $t('Hotels') }}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Do you need to book a hotel?')
                                                    }}
                                                </label>
                                                <select class="form-control" v-model="is_need_booking" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="1">{{ $t('yes') }}</option>
                                                    <option value="0">{{ $t('no') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="is_need_booking == '0'" class="row p10 pt-0 pb-0 mt-2">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Will you stay with a friend from the Saudi Cup?')
                                                    }}
                                                </label>
                                                <select class="form-control" v-model="stay_with_friend" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="1">{{ $t('yes') }}</option>
                                                    <option value="0">{{ $t('no') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-if="stay_with_friend == '1'" class="col-md-12">
                                            <div class="form-group relative">
                                                <label>
                                                    {{
                                                        $t('Please enter your friend registration number')
                                                    }} :
                                                </label>
                                                <input type="text" class="form-control"
                                                    :placeholder="$t('Registration number')"
                                                    v-model="registration_number"
                                                    @change="handleChangeRegistrationNumber" @blur="check_guest_exists"
                                                    :readonly="registration_number_verified" required>
                                                <LvProgressSpinner v-if="check_guest_loader" color="#d1b26e" size="28px"
                                                    class="suffix-loader" strokeWidth="3" />
                                                <img v-else-if="registration_number_verified == false"
                                                    src="@/assets/img/svg/x-circle.svg" width="20" class="suffix-icon">
                                                <img v-else-if="registration_number_verified == true"
                                                    src="@/assets/img/svg/check-circle.svg" width="20"
                                                    class="suffix-icon">
                                            </div>
                                        </div>
                                        <div v-else-if="stay_with_friend == '0'" class="col-md-12">
                                            <div class="form-group">
                                                <label>
                                                    {{
                                                        $t('Where will you stay?')
                                                    }}
                                                </label>
                                                <select class="form-control" v-model="stay_type" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="1">{{ $t('Hotel') }}</option>
                                                    <option value="0">{{ $t('External accommodation') }}</option>
                                                </select>
                                            </div>
                                            <div v-if="stay_type == '1'" class="form-group">
                                                <label>
                                                    {{
                                                        $t('Hotel name')
                                                    }} :
                                                </label>
                                                <input type="text" class="form-control" :placeholder="$t('Hotel name')"
                                                    v-model="hotel_reference" required>
                                            </div>
                                            <div v-if="stay_type != ''" class="form-group">
                                                <label>
                                                    {{
                                                        $t('Location')
                                                    }} :
                                                </label>
                                                <input @click="displayLvDialog = true" type="text"
                                                    class="form-control pointer" :placeholder="$t('Location')"
                                                    :value="location?.address" required>
                                                <LvDialog :header="$t('Select location')" v-model="displayLvDialog"
                                                    :style="{ width: '40%' }">
                                                    <GoogleMap api-key="AIzaSyDfmO7kuPEzGkJdDBAi0CDmpL7DXVV4oos"
                                                        class="google-map" :center="{ lat: 24.7136, lng: 46.6753, }"
                                                        :zoom="10" @click="handleMapClick">
                                                        <Marker :options="{ position: markerPosition }" />
                                                    </GoogleMap>
                                                    <template #footer>
                                                        <LvButton :label="$t('Select location')" icon="light-icon-check"
                                                            @click="displayLvDialog = false" class="lv--success"
                                                            :disabled="location == null" autofocus />
                                                    </template>
                                                </LvDialog>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="is_need_booking == '1'">
                                        <div class="row align-items-center mb-3">
                                            <div class="col-md-5">
                                                <div class="p10 bg-white">
                                                    <div class="hotel-img">
                                                        <img :src="this.hotel_img">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-7">
                                                <div class="row p10 pt-0 pb-0">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>{{ $t('Hotel name') }} :</label>
                                                            <select v-model="hotel_id" @change="changeHotel"
                                                                class="form-control">
                                                                <option v-for="hotel in hotels" :value="hotel.id">
                                                                    {{ hotel[this.$i18n.locale + '_name'] }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('reservation start date') }} :</label>
                                                            <VueDatePicker v-model="entry_date"
                                                                :enable-time-picker="false"
                                                                :start-date="formattedDate(this.policy.departure_to_riyadh_from_date)"
                                                                :min-date="formattedDate(this.policy.departure_to_riyadh_from_date)"
                                                                :max-date="formattedDate(this.policy.departure_to_riyadh_to_date)"
                                                                prevent-min-max-navigation
                                                                @internal-model-change="changeEntry"
                                                                :placeholder="$t('select2')" required />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('reservation end date') }} :</label>
                                                            <VueDatePicker v-model="exit_date" :disabled="!entry_date"
                                                                :enable-time-picker="false"
                                                                :start-date="this.add_days_to_date(entry_date, 1)"
                                                                :min-date="this.add_days_to_date(entry_date, 1)"
                                                                :max-date="formattedDate(this.policy.back_from_riyadh_to_date)"
                                                                prevent-min-max-navigation
                                                                @internal-model-change="changeEntry2"
                                                                :placeholder="$t('select2')" required />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>{{ $t('room price') }} :</label>
                                                            <input type="text" class="form-control" :value="room_price"
                                                                disabled>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>
                                                                {{
                                                                    $t('Room type')
                                                                }} :
                                                            </label>
                                                            <select class="form-control" v-model="room_type" required>
                                                                <option value="">{{ $t('select2') }}</option>
                                                                <option value="King Bed">{{ $t('King bed') }}</option>
                                                                <option value="Double Bed">{{ $t('Twin beds') }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div v-if="need_payment == 1 && show_payment_form && guest_packages.length > 0">
                        <div class="tour_details_right_sidebar_wrapper">
                            <div class="tour_detail_right_sidebar">
                                <div class="tour_details_right_boxed">
                                    <div class="row no-margin align-items-center">
                                        <div class="col-md-6 col-6">
                                            <img src="@/assets/img/svg/card.svg">
                                            <div class="inline-middle pl-3 pr-3">
                                                <h4 class="bold  mb0">{{ $t('payment information') }}</h4>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="tour_booking_amount_area">
                                                <ul>
                                                    <li v-for="(item, index) in guest_packages"
                                                        v-bind:class="index == guest_packages.length - 1 ? 'last' : ''">
                                                        {{ item.service['service_name_' + $i18n.locale] }}
                                                        <span>
                                                            {{
                                                                item.service.service_name_en == "Flights" ?
                                                                    parseFloat(total).toFixed(2) :
                                                                    parseFloat(item.price).toFixed(2)
                                                            }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('Total Amount') }}
                                                        <span class="text-main">
                                                            {{ parseFloat(total_amount).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('discount') }}
                                                        <span class="text-danger">
                                                            {{ parseFloat(discount).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        {{ $t('Amount due') }}
                                                        <span class="text-main">
                                                            {{ parseFloat(amount_due).toFixed(2) }}
                                                            {{ $t('SAR') }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div v-if="payment_method == ''" class="col-md-12 mt-3">
                                            <div class="form-group">
                                                <label>
                                                    {{ $t('payment method') }}
                                                </label>
                                                <select class="form-control" v-model="payment_method"
                                                    @change="payment_method_change" required>
                                                    <option value="">{{ $t('select2') }}</option>
                                                    <option value="MADA">MADA</option>
                                                    <option value="VISA MASTER">VISA MASTER</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="mt-3">
                                                <form id="payment_form"
                                                    :action="saudi_cup_url + '/api/result/' + checkoutId + '?redirect_url=' + payment_redirect_url"
                                                    class="paymentWidgets" :data-brands="payment_method"></form>
                                            </div>
                                        </div>
                                        <div v-if="is_payment_loading == 1"
                                            class="col-md-12 text-center mt-5 mb-5 pt-5 pb-5">
                                            <lv-loader type="ball-pulse" :scale="1.3" :color="'#d1b26e'" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="(need_payment == 0 && sp_can_book_hotel && show_send_btn) || (sp_can_book_hotel && guest_packages.length == 0)"
                    class="col-lg-12">
                    <div class="tour_details_right_sidebar_wrapper">
                        <div class="tour_detail_right_sidebar mb20">
                            <div class="tour_details_right_boxed">
                                <div class="text-center">
                                    <button type="button" class="btn btn_theme btn_md w-35" @click="send"
                                        :disabled="check_guest_loader">
                                        {{ $t('Confirm the reservation') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
var that;
import $ from 'jquery';
import Tooltip from 'lightvue/tooltip';
import { toast } from 'vue3-toastify';
import LvLoader from 'lightvue/loaders';
import { addDaysToDate, frCaDateFormat } from '@/utils/dateUtils';
import LvDialog from 'lightvue/dialog';
import LvButton from 'lightvue/button';
import { GoogleMap, Marker } from 'vue3-google-map';
import LvProgressSpinner from 'lightvue/progress-spinner';
import guestService from '@/services/saudi-cup/guest/guest-service';
import { countExtraDayAtEnd } from '../../utils/dateUtils';
import paymentService from '@/services/saudi-cup/payment/payment-service';
export default {
    name: 'FlightConfirmationArea',
    directives: {
        tooltip: Tooltip,
    },
    data: () => ({
        searchData: [],
        allowed_to_request_hotel_reservation: 0,
        hotels: [],
        hotel_img: '',
        hotel_id: '',
        current_hotel: [],
        room_type: '',
        extra_room_type: '',
        arrival_time_to_riyadh: '',
        departure_time_for_riyadh: '',
        entry_hotel_date: '',
        exit_hotel_date: '',
        need_extra_end: false,
        need_assistance: '',
        count_extra_end: false,
        end_extra_date: '',
        essential_guest: 0,
        confirm: null,
        confirm_issue: false,
        entry_date: null,
        exit_date: null,
        total: 0,
        need_payment: 1,
        is_self_paying: 1,
        is_payment_loading: 0,
        payment_method: '',
        checkoutId: '',
        payment_redirect_url: '',
        hotel_reference: '',
        stay_type: '',
        registration_number: '',
        stay_with_friend: '',
        is_need_booking: '',
        policy: [],
        displayLvDialog: false,
        markerPosition: null,
        location: null,
        check_guest_loader: false,
        registration_number_verified: null,
        total_amount: 0,
        amount_due: 0,
        discount: 0,
        sp_can_book_hotel: false,
        guest_packages: [],
        packages: [],
        guest_data: [],
        need_start_extra: false,
        saudi_cup_url: process.env.VUE_APP_SAUDI_CUP_URL,
        main_guest_id: null,
        redirect_url: null,
        show_payment_form: true,
        departure_period: null,
        return_period: null,
        room_price: 0,
        passengers: [],
        show_send_btn: true,
    }),
    components: {
        LvLoader,
        GoogleMap,
        Marker,
        LvDialog,
        LvButton,
        LvProgressSpinner,
    },
    methods: {
        handleChangeRegistrationNumber() {
            this.check_guest_loader = true;
        },
        check_guest_exists() {
            if (!this.registration_number || this.registration_number_verified) return;
            this.check_guest_loader = true;
            guestService.check_guest_exists(this.registration_number).then(response => {
                var res = response.data.data;
                this.main_guest_id = res.id;
                this.check_guest_loader = false;
                this.registration_number_verified = true;
            }).catch(error => {
                this.registration_number_verified = false;
                this.check_guest_loader = false;
                this.registration_number = null;
                toast.error(this.$t('Invalid registration number'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            });
        },
        handleMapClick(event) {
            const latLng = event.latLng;
            this.markerPosition = {
                lat: latLng.lat(),
                lng: latLng.lng(),
            };
            this.getAddressFromCoordinates(latLng);
        },
        getAddressFromCoordinates(latLng) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: latLng }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    const place = results[0];
                    const address = place.formatted_address;
                    this.location = {
                        "lat": latLng.lat(),
                        "lng": latLng.lng(),
                        "address": address
                    };
                }
            });
        },
        payment_method_change() {
            this.is_payment_loading = 1;
            $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
            var body = {
                guest_id: this.guest_data.guest.id,
                payment_method: this.payment_method,
                amount: parseFloat(this.amount_due).toFixed(2),
                subject: 'flight',
            };
            paymentService.prepare_the_checkout(body).then((response) => {
                this.checkoutId = response.data.checkoutId;
                this.payment_redirect_url = window.location.origin + '/no-flights-confirmation/';
                let recaptchaScript = document.createElement('script');
                recaptchaScript.setAttribute('src', `${process.env.VUE_APP_FLIGHT_MODE == 'live' ? 'https://eu-prod.oppwa.com' : 'https://eu-test.oppwa.com'}/v1/paymentWidgets.js?checkoutId=` + this.checkoutId);
                recaptchaScript.setAttribute('strategy', 'afterInteractive');
                document.head.appendChild(recaptchaScript);
                recaptchaScript.onload = () => {
                    setTimeout(() => {
                        $('.wpwl-control-brand').children('option').each(function () {
                            $(this).html(that.$t($(this).text()));
                        });

                        $(document).find('.wpwl-label-cardNumber').html(this.$t('Card Number'));
                        $(document).find('[name="card.number"]').attr('placeholder', this.$t('Card Number'));

                        if (that.$i18n.locale === 'ar') {
                            $(document).find('[name="card.number"]').css('direction', 'ltr');
                            $(document).find('[name="card.number"]').css('text-align', 'right');
                        }

                        $(document).find('.wpwl-label-expiry').html(this.$t('Expiry Date'));
                        $(document).find('.wpwl-control-expiry').attr('placeholder', this.$t('MM / YY'));

                        $(document).find('.wpwl-label-cvv').html(this.$t('CVV'));
                        $(document).find('[name="card.cvv"]').attr('placeholder', this.$t('CVV'));

                        $(document).find('.wpwl-label-cardHolder').html(this.$t('Card holder'));
                        $(document).find('.wpwl-control-cardHolder').attr('placeholder', this.$t('Card holder'));

                        $(document).find('.wpwl-button-pay').html(this.$t('Pay now'));
                        that.is_payment_loading = 0;
                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                    }, 100);
                }
            });
        },
        formattedDate(date) {
            const parts = date.split('/');
            return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        },
        date_format(date) {
            return frCaDateFormat(date);
        },
        add_days_to_date(date, days) {
            return addDaysToDate(date, days);
        },
        count_extra_day_at_end(date1, date2) {
            return countExtraDayAtEnd(date1, date2);
        },
        changeEntry(date) {
            const dateStr1 = date;
            const dateStr2 = this.entry_date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 50);
            }
            this.entry_hotel_date = this.date_format(this.entry_date);
        },
        changeEntry2(date) {
            const dateStr1 = date;
            const dateStr2 = this.entry_date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 50);
            }
            this.exit_hotel_date = this.date_format(this.exit_date);
        },
        changeHotel() {
            this.need_assistance = '';
            this.confirm = null;
            this.current_hotel = this.hotels.filter(item => {
                return item.id == this.hotel_id;
            })[0];

            var room_prices = this.current_hotel.room_prices;
            if (room_prices) {
                var room_type = this.guest_data.policy.room_type.toLowerCase();
                if (this.passengers.length == 1) {
                    this.room_price = room_prices[room_type + '_sale_price']
                } else {
                    this.room_price = room_prices[room_type + '_sale_price_with_companion'];
                }
            }
            if (this.current_hotel?.images?.length > 0) {
                this.hotel_img = `${this.saudi_cup_url}/storage` + this.current_hotel.images[0].image;
            } else {
                this.hotel_img = 'https://placehold.co/600x300';
            }
        },
        async send() {
            var forms = document.querySelectorAll('.needs-validation')
            if (forms.length > 0) {
                forms[0].classList.add('was-validated');
                if (!forms[0].checkValidity()) {
                    toast.error(this.$t('All fields are required'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
            }

            $('.pre-loader').show();

            const companion_guest_id = this.sp_can_book_hotel ? this.passengers.filter((element) => element.id !== this.guest_data.guest.id).find(() => true) : null;

            var hotel_body = {
                is_need_booking: this.is_need_booking,
                hotel_id: this.hotel_id,
                guests: [this.guest_data?.guest?.id],
                on_his_expense: this.is_self_paying,
                start_date: this.entry_hotel_date,
                end_date: this.exit_hotel_date,
                type: this.guest_data.policy.room_type,
                bed_type: this.room_type,
                self_paying_description: this.sp_can_book_hotel
                    ? JSON.stringify({
                        text: `I want to book (${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}) nights at ${this.current_hotel.en_name} hotel, from ${this.entry_hotel_date} to ${this.exit_hotel_date}, with ${this.room_type}`,
                        variables: {
                            nights: `${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}`,
                            hotel_name: this.current_hotel.en_name,
                            start_date: this.entry_hotel_date,
                            end_date: this.exit_hotel_date,
                            type: this.room_type,
                            main_guest_id: this.stay_with_friend == '1' ? this.main_guest_id : null,
                            companion_guest_id: companion_guest_id ? companion_guest_id.id : null
                        }
                    })
                    : {},
                extra_nights: this.need_assistance == 1 ? "i want " + this.count_extra_end + " extra nights from " + this.exit_hotel_date + " to " + this.end_extra_date + " and room type is (" + this.extra_room_type + ")" : null
            };

            if (this.is_need_booking == '0') {
                hotel_body = {
                    is_need_booking: this.is_need_booking,
                    guests: [this.guest_data?.guest?.id],
                    on_his_expense: this.is_self_paying,
                    registration_number: this.registration_number,
                    hotel_reference: this.hotel_reference,
                    site_url: JSON.stringify(this.location),
                    extra_nights: null,
                    self_paying_description: this.sp_can_book_hotel
                        ? JSON.stringify({
                            text: `I want to book (${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}) nights at ${this.current_hotel.en_name} hotel, from ${this.entry_hotel_date} to ${this.exit_hotel_date}, with ${this.room_type}`,
                            variables: {
                                nights: `${this.count_extra_day_at_end(this.entry_hotel_date, this.exit_hotel_date)}`,
                                hotel_name: this.current_hotel.en_name,
                                start_date: this.entry_hotel_date,
                                end_date: this.exit_hotel_date,
                                type: this.room_type,
                                main_guest_id: this.stay_with_friend == '1' ? this.main_guest_id : null,
                                companion_guest_id: companion_guest_id ? companion_guest_id.id : null
                            }
                        })
                        : {},
                };
            }
            await guestService.send_hotel_details(hotel_body).then((response) => {
                this.show_send_btn = false;
                if (this.guest_packages.length == 0) {
                    var data = {
                        guest_package_services_id: [
                            this.packages[0].id
                        ],
                        guest_package_services_price: [this.packages[0].price],
                        guest_package_services_tickets_num: [1]
                    };
                    guestService.confirm_guest_package(data).then((response) => {
                        $('.pre-loader').hide();
                        toast.success(this.$t('Your reservation was completed successfully'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        setTimeout(() => {
                            localStorage.clear();
                            window.location = this.redirect_url;
                        }, 2000);
                    });
                } else {
                    $('.pre-loader').hide();
                    toast.success(this.$t('Your reservation was completed successfully'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    setTimeout(() => {
                        localStorage.clear();
                        window.location = this.redirect_url;
                    }, 2000);
                }
            }).catch(error => {
                $('.pre-loader').hide();
                toast.error(this.$t('An error occurred during the booking process'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            });
        },
        async get_guest_packages() {
            this.total_amount = 0;
            var data = JSON.parse(localStorage.getItem('packages'));
            data.forEach(element => {
                this.total_amount += parseFloat(element.price);
            });
            this.packages = data;
            this.guest_packages = data.filter(element => element.service.service_name_en != 'Hotels');
            this.sp_can_book_hotel = data.some(element => element.service.service_name_en === 'Hotels');
            if (this.guest_packages.length > 0) {
                this.discount = (parseFloat(this.guest_packages[0].package.discount) / 100) * this.total_amount;
                this.amount_due = this.total_amount - this.discount;
            }
            if (this.need_payment == 1 && this.guest_packages.length > 0) {
                var checkoutId = this.$route.params.checkoutId;
                var is_package_confirmed = localStorage.getItem('is_package_confirmed');
                if (checkoutId) {
                    await paymentService.check_payment_result(checkoutId).then((response) => {
                        if (response.data.status == "Transaction succeeded") {
                            this.need_payment = 0;
                            var data = {
                                guest_package_services_id: [
                                    this.guest_packages[0].id
                                ],
                                guest_package_services_price: [this.guest_packages[0].price],
                                guest_package_services_tickets_num: [1]
                            };
                            if (is_package_confirmed != '1') {
                                guestService.confirm_guest_package(data).then((response) => {
                                    localStorage.setItem('is_package_confirmed', 1);
                                    toast.success(this.$t('The payment was completed successfully'), {
                                        autoClose: 5000,
                                        position: toast.POSITION.TOP_CENTER,
                                        closeButton: false
                                    });
                                    $('.pre-loader').hide();
                                    if (!this.sp_can_book_hotel) {
                                        setTimeout(() => {
                                            localStorage.clear();
                                            window.location = this.redirect_url;
                                        }, 2000);
                                    } else {
                                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                                    }
                                });
                            } else {
                                $('.pre-loader').hide();
                                $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                            }
                        } else {
                            $('.pre-loader').hide();
                            this.need_payment = 1;
                            toast.error(this.$t('Payment failed'), {
                                autoClose: 5000,
                                position: toast.POSITION.TOP_CENTER,
                                closeButton: false
                            });
                        }
                    }).catch(error => {
                        $('.pre-loader').hide();
                        toast.error(this.$t('checkout Id is not correct'), {
                            autoClose: 5000,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                    });
                } else {
                    $('.pre-loader').hide();
                }
            } else {
                $('.pre-loader').hide();
            }
        },
    },
    mounted() {
        that = this;
        this.redirect_url = localStorage.getItem("redirect_url");
        this.guest_data = JSON.parse(localStorage.getItem("guest_data"));
        this.policy = this.guest_data.policy;
        this.is_self_paying = localStorage.getItem("is_self_paying");
        this.need_payment = localStorage.getItem("is_self_paying");
        this.essential_guest = localStorage.getItem("essential_guest");

        const guest = this.guest_data.guest;
        this.passengers.push({
            "id": guest.id,
            "encrypted_id": guest.encrypted_id,
            "title": guest.gender == 'Female' ? 'ms' : 'mr',
            "first_name": guest.en_first_name,
            "last_name": guest.en_last_name,
            "registration_number": guest.registration_number,
            "category": guest.category.en_name,
            "birthday": guest.birthdate,
            "email": guest.email,
            "mobile": guest.mobile,
            "nationality": guest.nationality.code,
            "passport_number": guest.passport_number,
            "passport_issue_date": guest.passport_issue_date,
            "passport_issuing_country": guest.place_of_passport_issue,
            "passport_expiry_date": guest.passport_expire_date,
            "LoyaltyProgram": [{ "programOwner": null, "id": null }],
        });
        guest.companions.forEach(element => {
            if (element.data_status == "Complete") {
                this.passengers.push({
                    "id": element.id,
                    "encrypted_id": element.encrypted_id,
                    "title": element.gender == 'Female' ? 'ms' : 'mr',
                    "first_name": element.en_first_name,
                    "last_name": element.en_last_name,
                    "registration_number": element.registration_number,
                    "category": element.category.en_name,
                    "birthday": element.birthdate,
                    "email": element.email,
                    "mobile": element.mobile,
                    "nationality": element.nationality.code,
                    "passport_number": element.passport_number,
                    "passport_issue_date": element.passport_issue_date,
                    "passport_issuing_country": element.place_of_passport_issue,
                    "passport_expiry_date": element.passport_expire_date,
                    "LoyaltyProgram": [{ "programOwner": null, "id": null }],
                });
            }
        });

        $('.pre-loader').show();

        this.get_guest_packages();

        if (this.allowed_to_request_hotel_reservation == 1 || this.sp_can_book_hotel) {
            this.guest_data.policy.hotels.forEach(element => {
                this.hotels.push(element.hotel);
            });
            this.current_hotel = this.hotels[0];
            this.hotel_id = this.current_hotel.id;

            var room_prices = this.current_hotel.room_prices;
            if (room_prices) {
                var room_type = this.guest_data.policy.room_type.toLowerCase();
                if (this.passengers.length == 1) {
                    this.room_price = room_prices[room_type + '_sale_price']
                } else {
                    this.room_price = room_prices[room_type + '_sale_price_with_companion'];
                }
            }

            if (this.current_hotel?.images?.length > 0) {
                this.hotel_img = `${this.saudi_cup_url}/storage` + this.current_hotel.images[0].image;
            } else {
                this.hotel_img = 'https://placehold.co/600x300';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.drawer-bar {
    width: 95%;
    display: block;
    border-bottom: 1px solid rgb(227, 232, 239);
    margin: 10px auto;
    border-bottom: 2px solid rgb(201, 211, 223);
}

.drawer-bar-item {
    width: 50%;
    height: 45px;
    font-size: 14px;
    border: none;
    background: none;
    position: relative;

}

.drawer-container {
    margin: auto;
    width: 100%;
    padding: 10px 0px;
}

.drawer-bar-item.active:before {
    content: "";
    height: 2px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -2px;
    transition: all .3s;
    transform: scale(1);
    background-color: var(--main-color);
}
.dash-line {
    border-top: 1px dashed #646464;
}
.ticket-hole {
    position: relative;
}
.ticket-hole:before {
    left: -28px;
}
.ticket-hole:after, .ticket-hole:before {
    content: '';
    width: 20px;
    height: 20px;
    background-color: #f0eee9;
    position: absolute;
    top: -12px;
    border-radius: 50%;
}
.ticket-hole:after {
    right: -28px;
}
.ticket-hole>hr {
    margin-top: 15px;
    margin-bottom: 15px;
    border-top: 1px dashed #646464;
}
@media (min-width: 768px) {
    .container {
        width: 750px;
    }
}
@media (min-width: 992px) {
    .container {
        width: 970px;
    }
}

@media (min-width: 1200px) {
    .container {
        width: 1350px;
    }
}

.color-label {
    color: #d1b26e!important;
    font-weight: 700!important;
    .note{
        color: rgb(192, 160, 52);
    }
}
.form-control{
        padding: 5px 22px;
        font-size: 14px;
        height: 40px;
        border-radius: 0.25rem;
}
label{
    font-size: 14px;
    margin-bottom: 8px;
    color: #d1b26e;
    font-weight: 600;
}
.form-group{
    margin-bottom: 1rem;
}
.section_padding {
    padding: 60px 0;
    background: #d1b26e12;
    min-height: 500px;
}
.mb20 {
    margin-bottom: 20px !important;
}
.sticky-parent {
    bottom: 0px;
    position: sticky !important;
    top: 215px;
    height: 100%;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}
.mb0 {
    margin-bottom: 0px;
}
.h4,
h4 {
    font-size: 18px;
}
.no-margin {
    margin: 0;
}
.itinerary-content {
    background-color: #fff;
    border-radius: 3px;
    padding-bottom: 5px;
}
.p10 {
    padding: 10px;
}

.bold {
    font-weight: 500;
    font-style: normal;
}
.ml5 {
    margin-left: 5px !important;
}

.mr5 {
    margin-right: 5px !important;
}
.hotel-img{
    width: 100%;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #a5a5a5;
    img{
        width: 100%;
    }
}
@media only screen and (max-width: 600px) {
    .sticky-parent {
        position: relative !important;
        top: 0px !important;
    }
    .hotel-img {
        min-height: 100% !important;
    }
    .opt-btn-div{
        button.btn{
            width: 50% !important;
        }
    }
}
</style>
<style lang="scss">
body:has(.fligh_confirmation) .lv-tooltip .lv-tooltip-text {
    background: #fff;
    color: #495057;
    white-space: initial;
    direction: ltr;
    min-width: 200px;
    padding: 5px 10px;

    div{
        border-bottom: 1px dashed #e0e0e0;
        line-height: 35px;
        font-size: 14px;
        &:last-child{
            border-bottom: none !important;
        }
    }
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
}
.section_padding {
    font-size: 14px;
    letter-spacing: .01em;
}
.itinerary-content {
    background-color: #fff;
    border-radius: 3px;
    padding: 20px 10px;
    box-shadow: -4px -5px 14px rgba(0, 0, 0, 0.08), 5px 8px 16px rgba(0, 0, 0, 0.08);
}
.form-group:has(select) {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .form-group select.form-control {
    width: 100%;
    padding: 5px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px !important;
    font-size: 16px;
    color: #495057;
    background-color: #fff;
    appearance: none;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }

  .form-group select.form-control:focus {
    border-color: var(--main-color);
  }

  
  .form-group:has(select):focus-within::after {
    transform: translateY(-50%) rotate(180deg);
  }
  .form-group select.form-control option {
    background-color: #fff;
    color: #495057;
    font-size: 16px;
    padding: 10px;
  }
  .form-group  select.form-control option:checked {
    background-color:  var(--main-color);
    color: #fff;
  }
.google-map{
    width: 100%; height: 400px;border: 1px solid #ced4da;border-radius: 6px;
}
.lv-dialog-mask {
    z-index: 10078;
}
.lv-dialog-content {
    overflow-y: hidden;
}
.lv-dialog .lv-dialog-header {
    padding: 1rem 1.5rem;
}
.lv-dialog .lv-dialog-footer {
    display: flex;
    justify-content: flex-end;
}
.lv-dialog .lv-dialog-content {
    padding: 0 1.5rem 1.5rem 1.5rem;
}
.lv-dialog .lv-dialog-header .lv-dialog-title {
    font-weight: 500;
    font-size: 1.1rem;
}
.rtl{
    .lv-button .lv-button__prepend {
        margin-left: 0.5rem;
    }
    .suffix-loader{
        left: 10px;
        right: unset;
    }
    .suffix-icon{
        left: 12px;
        right: unset;
    }
    .form-group:has(select)::after {
        left: 20px;
        right: unset;
    }
}
.form-group:has(select)::after {
    content: '';
    position: absolute;
    top: 70%;
    right: 20px;
    width: 0;
    height: 0;
    pointer-events: none;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #757575;
    transform: translateY(-50%);
  }
.suffix-loader{
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.suffix-icon{
    position: absolute;
    right: 12px;
    bottom: 10px;
}
.fligh_confirmation{
    .lv-button {
        opacity: 1 !important;
        background-color: var(--main-color) !important;
    }
}
@media only screen and (max-width: 600px) {
    .lv-dialog {
        width: 95% !important;
    }
    .lv-dialog .lv-dialog-footer {
        padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
    }
}
</style>
<style scoped>
.footer .cta-outer-wrapper .cta-inner-wrapper .item .label-total-price {
    color: #212121;
    font-family: basic-sans-alt;
    font-weight: 700;
    font-size: 22px;
    letter-spacing: 0;
    line-height: 26px;
    margin: 0 0 16px
}

.footer:after {
    content: "";
    position: absolute;
    top: -34px;
    left: 16px;
    width: calc(100% - 16px - 16px);
    height: 34px;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
    pointer-events: none
}

@media only screen and (min-width:612px) {
    .footer:after {
        top: -51px;
        left: 28px;
        width: calc(100% - 28px - 28px);
        height: 51px
    }
}

@media only screen and (min-width:924px) {
    .footer:after {
        top: -51px;
        left: 32%;
        width: 64%;
        height: 51px;
    }
}

.content .seat-selection-wrapper .group .passenger {
    display: block;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
}

.content .seat-selection-wrapper .group .active.passenger,
.content .seat-selection-wrapper .group .passenger:hover {
    border-radius: 4px;
    background-color: #eefff8
}

@media only screen and (max-width:611px) {
    .content {
        bottom: 146px
    }
}

@media only screen and (min-width:924px) {
    .content {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-items: flex-start;
        width: 100%;
        height: calc(100% - 60px);
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper,
    .content .seat-selection-wrapper {
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: auto;
        align-self: auto;
        min-width: 0;
        min-height: auto
    }
}

.content .seat-selection-wrapper {
    padding: 16px 21px 0
}

@media only screen and (min-width:612px) {
    .content .seat-selection-wrapper {
        padding: 28px 28px 0
    }
}

@media only screen and (min-width:924px) {
    .content .seat-selection-wrapper {
        width: 300px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 32px 8px 0 25px
    }
}

.content .seat-selection-wrapper .group {
    margin-bottom: 14px
}

.content .seat-selection-wrapper .group:last-child {
    margin-bottom: 2px
}

.content .seat-selection-wrapper .group .flight {
    color: #212121;
    font-family: basic-sans-alt;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    margin: 0 0 6px
}

.content .seat-selection-wrapper .group .passenger {
    color: #424242;
    font-family: roboto;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 36px;
    margin: 0;
    padding: 0 14px;
    text-decoration: none
}

.content .seat-selection-wrapper .group .passenger.condensed-item {
    line-height: 26px
}

@media only screen and (max-width:923px) {
    .content .seat-map-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper {
        margin-top: 14px;
        padding-left: 28px;
        padding-right: 28px;
        width: 650px;
        height: calc(100% - (32px - 18px));
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 25px;
    }
}

.content .seat-map-wrapper {
    margin-bottom: 34px
}

@media only screen and (min-width:612px) {
    .content .seat-map-wrapper {
        margin-bottom: 51px
    }
}

@media only screen and (min-width:924px) {
    .content .seat-map-wrapper {
        margin-bottom: 51px
    }
}

.footer {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

@media only screen and (max-width:611px) {
    .footer {
        padding: 10px 0 16px
    }
}

@media only screen and (max-width:923px) {
    .footer {
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 10px 0 28px;
        background: #fff;
        box-sizing: border-box;
        width: 100%;
        height: 146px
    }
}

@media only screen and (min-width:924px) {
    .footer {
        position: relative;
        padding: 0px 32px 0px;
        box-sizing: border-box;
        align-items: center;
    }
}

.footer .cta-outer-wrapper,
.footer .legend-outer-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    flex-basis: 100%
}

@media only screen and (min-width:924px) {
    .footer .cta-outer-wrapper,
    .footer .legend-outer-wrapper {
        flex-basis: 50%
    }
}

.footer .legend-outer-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    margin-bottom: 10px
}

@media only screen and (min-width:924px) {
    .footer .legend-outer-wrapper {
        margin: 0;
        justify-content: initial
    }
}

.footer .legend-outer-wrapper .legend-inner-wrapper,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend:not(:first-child) {
    margin-left: 14px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .label {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box {
    width: 14px;
    height: 14px;
    border: 1px solid #8e9195;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    margin-right: 8px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.selected {
    border-color: var(--main-color);
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.selected>div {
    color: #fff
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available {
    border-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:not(.info-box) {
    cursor: pointer
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:hover:not(.selected, .info-box) {
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.available:hover:not(.selected, .info-box) .seat-number {
    color: #fff
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked {
    border-color: #8e9195;
    background-color: #f5f5f5
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    background-color: #8e9195
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied {
    border-color: var(--main-color);
    background-color: #eefff8
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before {
    background-color: var(--main-color)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked {
    position: relative;
    overflow: hidden
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 28px
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:before,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:before {
    transform: rotate(45deg);
    right: calc(50% + 1px)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:after,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:after {
    transform: rotate(-45deg);
    left: calc(50% + 1px)
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied:not(.info-box),
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked:not(.info-box) {
    cursor: not-allowed
}

.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.occupied .seat-number,
.footer .legend-outer-wrapper .legend-inner-wrapper .legend .info-box.blocked .seat-number {
    display: none
}

.footer .cta-outer-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

@media only screen and (min-width:924px) {
    .footer .cta-outer-wrapper {
        justify-content: flex-end
    }
}

.footer .cta-outer-wrapper .cta-inner-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
    align-items: flex-end;
    min-width: 260px
}

.footer .cta-outer-wrapper .cta-inner-wrapper .item {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto
}

.footer .cta-outer-wrapper .cta-inner-wrapper .item .btn-confirm {
    margin-left: 14px
}
.row-div .seat .seat-number {
    color: #424242;
    font-family: roboto;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px
}

.row-div .emergency-exit-row {
    position: relative
}

.row-div .emergency-exit-row:before {
    position: absolute;
    top: -12.5px;
    color: #ff5736;
    font-family: roboto-condensed;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 13px
}

@media only screen and (min-width:612px) {
    .row-div .emergency-exit-row:before {
        top: -15.5px
    }
}

@media only screen and (min-width:924px) {
    .row-div .emergency-exit-row:before {
        top: -15.5px
    }
}

.row-div .emergency-exit-row:after {
    position: absolute;
    top: -14px;
    width: 2px;
    height: 16px;
    background-color: #e2e3e4
}

@media only screen and (min-width:612px) {
    .row-div .emergency-exit-row:after {
        top: -17px
    }
}

@media only screen and (min-width:924px) {
    .row-div .emergency-exit-row:after {
        top: -17px
    }
}

.row-div .emergency-exit-row:first-child:before,
.row-div .emergency-exit-row:last-child:before {
    content: "EXIT"
}

.row-div .emergency-exit-row:first-child:after,
.row-div .emergency-exit-row:last-child:after {
    content: ""
}

.row-div .emergency-exit-row:first-child:before {
    left: 5px
}

.row-div .emergency-exit-row:first-child:after {
    left: 0
}

.row-div .emergency-exit-row:last-child:before {
    right: 5px
}

.row-div .emergency-exit-row:last-child:after {
    right: 0
}

.row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
    top: -18.5px
}

@media only screen and (min-width:612px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
        top: -24.5px
    }
}

@media only screen and (min-width:924px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:before {
        top: -24.5px
    }
}

.row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
    top: -20px
}

@media only screen and (min-width:612px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
        top: -26px
    }
}

@media only screen and (min-width:924px) {
    .row-div .extra-legroom.seat-wrapper.emergency-exit-row:after {
        top: -26px
    }
}
.aircraft {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center
}

.aircraft .cabins-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    flex-shrink: 0
}

.aircraft .cabins-wrapper .cabin {
    padding: 0 1px
}

@media only screen and (min-width:612px) {
    .aircraft .cabins-wrapper .cabin {
        padding: 0 4px
    }
}

@media only screen and (min-width:924px) {
    .aircraft .cabins-wrapper .cabin {
        padding: 0 4px
    }
}

.row-div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    align-items: flex-end
}

.row-div .aisle,
.row-div .seat-wrapper {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    align-self: auto;
    min-width: 0;
    min-height: auto;
    margin: 12px 1px 0
}

@media only screen and (min-width:612px) {
    .row-div .aisle,
    .row-div .seat-wrapper {
        margin: 18px 4px 0
    }
}

@media only screen and (min-width:924px) {
    .row-div .aisle,
    .row-div .seat-wrapper {
        margin: 18px 4px 0
    }
}

.row-div .seat-wrapper.extra-legroom {
    margin-top: 24px
}

@media only screen and (min-width:612px) {
    .row-div .seat-wrapper.extra-legroom {
        margin-top: 36px
    }
}

@media only screen and (min-width:924px) {
    .row-div .seat-wrapper.extra-legroom {
        margin-top: 36px
    }
}

.row-div .seat {
    width: 28px;
    height: 28px;
    border: 1px solid #8e9195;
    background-color: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    -webkit-user-select: none;
    user-select: none
}

.row-div .seat.selected {
    border-color: var(--main-color);
    background-color: var(--main-color)
}

.row-div .seat.selected>div {
    color: #fff
}

.row-div .seat.available {
    border-color: var(--main-color)
}

.row-div .seat.available:not(.info-box) {
    cursor: pointer
}

.row-div .seat.available:hover:not(.selected, .info-box) {
    background-color: var(--main-color)
}

.row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
    color: #fff
}

.row-div .seat.blocked {
    border-color: #8e9195;
    background-color: #f5f5f5
}

.row-div .seat.blocked:after,
.row-div .seat.blocked:before {
    background-color: #8e9195
}

.row-div .seat.occupied {
    border-color: var(--main-color);
    background-color: #eefff8
}

.row-div .seat.occupied:after,
.row-div .seat.occupied:before {
    background-color: var(--main-color)
}

.row-div .seat.occupied,
.row-div .seat.blocked {
    position: relative;
    overflow: hidden
}

.row-div .seat.occupied:after,
.row-div .seat.occupied:before,
.row-div .seat.blocked:after,
.row-div .seat.blocked:before {
    content: "";
    position: absolute;
    top: -52.5%;
    width: 1px;
    height: 56px
}

.row-div .seat.occupied:before,
.row-div .seat.blocked:before {
    transform: rotate(45deg);
    right: calc(50% + 1px)
}

.row-div .seat.occupied:after,
.row-div .seat.blocked:after {
    transform: rotate(-45deg);
    left: calc(50% + 1px)
}

.row-div .seat.occupied:not(.info-box),
.row-div .seat.blocked:not(.info-box) {
    cursor: not-allowed
}

.row-div .seat.occupied .seat-number,
.row-div .seat.blocked .seat-number {
    display: none
}

@media only screen and (min-width:612px) {
    .row-div .seat {
        width: 42px;
        height: 42px;
        border: 1px solid #8e9195;
        background-color: #fff;
        border-radius: 14px;
        box-sizing: border-box
    }
    .row-div .seat.selected {
        border-color: var(--main-color);
        background-color: var(--main-color)
    }
    .row-div .seat.selected>div {
        color: #fff
    }
    .row-div .seat.available {
        border-color: var(--main-color)
    }
    .row-div .seat.available:not(.info-box) {
        cursor: pointer
    }
    .row-div .seat.available:hover:not(.selected, .info-box) {
        background-color: var(--main-color)
    }
    .row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
        color: #fff
    }
    .row-div .seat.blocked {
        border-color: #8e9195;
        background-color: #f5f5f5
    }
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        background-color: #8e9195
    }
    .row-div .seat.occupied {
        border-color: var(--main-color);
        background-color: #eefff8
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before {
        background-color: var(--main-color)
    }
    .row-div .seat.occupied,
    .row-div .seat.blocked {
        position: relative;
        overflow: hidden
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        content: "";
        position: absolute;
        top: -52.5%;
        width: 1px;
        height: 84px
    }
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:before {
        transform: rotate(45deg);
        right: calc(50% + 1px)
    }
    .row-div .seat.occupied:after,
    .row-div .seat.blocked:after {
        transform: rotate(-45deg);
        left: calc(50% + 1px)
    }
    .row-div .seat.occupied:not(.info-box),
    .row-div .seat.blocked:not(.info-box) {
        cursor: not-allowed
    }
    .row-div .seat.occupied .seat-number,
    .row-div .seat.blocked .seat-number {
        display: none
    }
}

@media only screen and (min-width:924px) {
    .row-div .seat {
        width: 42px;
        height: 42px;
        border: 1px solid #8e9195;
        background-color: #fff;
        border-radius: 14px;
        box-sizing: border-box
    }
    .row-div .seat.selected {
        border-color: var(--main-color);
        background-color: var(--main-color)
    }
    .row-div .seat.selected>div {
        color: #fff
    }
    .row-div .seat.available {
        border-color: var(--main-color)
    }
    .row-div .seat.available:not(.info-box) {
        cursor: pointer
    }
    .row-div .seat.available:hover:not(.selected, .info-box) {
        background-color: var(--main-color)
    }
    .row-div .seat.available:hover:not(.selected, .info-box) .seat-number {
        color: #fff
    }
    .row-div .seat.blocked {
        border-color: #8e9195;
        background-color: #f5f5f5
    }
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        background-color: #8e9195
    }
    .row-div .seat.occupied {
        border-color: var(--main-color);
        background-color: #eefff8
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before {
        background-color: var(--main-color)
    }
    .row-div .seat.occupied,
    .row-div .seat.blocked {
        position: relative;
        overflow: hidden
    }
    .row-div .seat.occupied:after,
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:after,
    .row-div .seat.blocked:before {
        content: "";
        position: absolute;
        top: -52.5%;
        width: 1px;
        height: 84px
    }
    .row-div .seat.occupied:before,
    .row-div .seat.blocked:before {
        transform: rotate(45deg);
        right: calc(50% + 1px)
    }
    .row-div .seat.occupied:after,
    .row-div .seat.blocked:after {
        transform: rotate(-45deg);
        left: calc(50% + 1px)
    }
    .row-div .seat.occupied:not(.info-box),
    .row-div .seat.blocked:not(.info-box) {
        cursor: not-allowed
    }
    .row-div .seat.occupied .seat-number,
    .row-div .seat.blocked .seat-number {
        display: none
    }
}

.row-div .seat .seat-number {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    height: 100%
}

@media only screen and (max-width:611px) {
    .row-div .seat .seat-number {
        font-size: 10px
    }
}

.row-div .aisle {
    width: 6px;
    height: 28px
}

@media only screen and (min-width:612px) {
    .row-div .aisle {
        width: 16px;
        height: 42px
    }
}

@media only screen and (min-width:924px) {
    .row-div .aisle {
        width: 16px;
        height: 42px
    }
}
@media only screen and (min-width: 924px) {
    .seatmap-container{
        flex-grow: 0;
        flex-shrink: 1;
        flex-basis: auto;
        align-self: auto;
        min-width: 0;
        min-height: auto;
        padding: 0;
        height: calc(100vh - 180px);
        direction: ltr;
        width: 100%;
    }
}
@media only screen and (min-width: 924px) {
    .p-seatmap {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        width: 100%;
    }
}
  .seat-map-wrapper::-webkit-scrollbar {
    width: 10px;
  }
  .seat-map-wrapper::-webkit-scrollbar-track {
    background: #f6f6f6;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .seat-map-wrapper::-webkit-scrollbar-thumb {
    background: var(--main-color);
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .seat-map-wrapper::-webkit-scrollbar-thumb:hover {
    background:  var(--main-color);
  }
  .ek-ancillary-container .clickable-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: none;
}
.exbag-card {
    height: inherit;
    flex-direction: column;
    padding: 0;
    justify-content: space-between;
}
.exbag-card {
    letter-spacing: .02em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smooth: never;
    display: flex;
    flex-direction: row;
    padding: 16px;
    border-radius: 8px;
    margin: 0;
    flex-grow: 1;
}
</style>
